const initFooterHeight = (footer) => {

    const body = document.querySelector('body');

    const setFooterSize = () => {
        let footerHeight = footer.offsetHeight;
        body.style.setProperty('--footer-height', `${footerHeight}px`)
    }

    window.addEventListener('resize', () =>{
        setFooterSize();
    })

    window.addEventListener('DOMContentLoaded', () =>{
        setFooterSize();
    })
}

export default initFooterHeight;